import { useContext } from "react";
import {
  BookmarkContext,
  type BookmarkContextType,
} from "../contexts/BookmarkContext";

export function useBookmarkContext(): BookmarkContextType {
  const context = useContext(BookmarkContext);
  if (context === undefined) {
    throw new Error(
      "useBookmarkContext must be used within a BookmarkProvider",
    );
  }
  return context;
}
